import { render, staticRenderFns } from "./BuscadorMantenedorSolicitud.vue?vue&type=template&id=c076f820&"
import script from "./BuscadorMantenedorSolicitud.vue?vue&type=script&lang=ts&"
export * from "./BuscadorMantenedorSolicitud.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports